import '@/plugin/web_ide/WebIde'
import Vue from 'vue'
import App from './Index.vue'
import '@/style/bulma.sass'
import '@/style/style.styl'
import './web.styl'
import Axios from 'axios'

import VTooltip from 'v-tooltip'
import ApiPlugin from '@/plugin/api'
import FiltersPlugin from '@/plugin/filters'
import Notification from '@/plugin/notification'
import ColorIcon from '@/components/color_icon/ColorIcon'
import Transition from '@/components/transitions/Transition'
import PortalVue from 'portal-vue'
import ModalCard from '@/common/layout/ModalCard'

Vue.config.productionTip = false
Vue.use(VTooltip)
Vue.use(ApiPlugin)
Vue.use(FiltersPlugin)
Vue.use(Notification)
Vue.use(PortalVue)

Vue.component('v-color-icon', ColorIcon)
Vue.component('v-transition', Transition)
Vue.component('modal-card', ModalCard)

const axios = Axios.create()

new Vue({
  apiData: new ApiPlugin.ApiData(axios),
  render: h => h(App)
}).$mount('#app')
